var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7274 0.107552L0 8.6104V28.6104L17.3205 38.6104L34.641 28.6104V8.6104L19.7274 0L19.7274 12.9817L21.1165 11.5926C22.0928 10.6163 23.6757 10.6163 24.652 11.5926C25.6283 12.5689 25.6283 14.1519 24.652 15.1282L18.9951 20.785L17.2274 22.5528L15.4596 20.785L9.80274 15.1282C8.82643 14.1519 8.82643 12.5689 9.80274 11.5926C10.7791 10.6163 12.362 10.6163 13.3383 11.5926L14.7274 12.9817V0.107552ZM8.82051 25.6104C8.82051 24.2297 9.9398 23.1104 11.3205 23.1104H22.8205C24.2012 23.1104 25.3205 24.2297 25.3205 25.6104C25.3205 26.9911 24.2012 28.1104 22.8205 28.1104H11.3205C9.9398 28.1104 8.82051 26.9911 8.82051 25.6104Z",
    fill: "#DFF8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.e23bf05f33652c3e06631a92c9fed17b.svg";
export { ForwardRef as ReactComponent };